export class UpdateTableContextResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "versionId",
            "baseName": "versionId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateTableContextResponse.attributeTypeMap;
    }
    constructor() {
    }
}
